module.exports = __webpack_public_path__ + "media/images/logo_co2unt-26e00e033492fc5f358f5f7db2dbb593.svg";